import { router } from '@lifedot/router'
import { useShortCodeDataPosts } from '@/hooks/use-short-code-data/use-short-code-data'
import { FC } from 'react'
import Link from 'next/link'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { mq } from '@lifedot/styles/mediaQuery'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import { Card } from '@lifedot/atoms/Card'
import Image from 'next/image'

const styles = {
  link: css({
    display: 'block',
    textDecoration: 'none',
    p: {
      margin: 0
    }
  }),
  label: css({
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: palette.main03,
    color: palette.white,
    padding: '4px 8px',
    fontWeight: 'bold',
    borderRadius: '0 0 4px 0'
  }),
  content: css({
    display: 'flex',
    padding: '8px 12px'
  }),
  img: css({
    width: 120,
    marginRight: 12,
    flexShrink: 0,
    [mq('sp')]: {
      width: '25%'
    }
  })
}

interface PostCardProp {
  slug: string
}

export const PostCard: FC<PostCardProp> = ({ slug }) => {
  const [post] = useShortCodeDataPosts([slug])

  if (!post) return null

  const { image, h1 } = post
  return (
    <Link href={router.post(slug)} passHref prefetch={false}>
      <a css={styles.link}>
        <Card shadow round={1} outlineWidth={1}>
          <p css={[typography.textS, styles.label]}>
            <DescriptionOutlinedIcon fontSize="small" />
            この記事も読まれています
          </p>
          <div css={styles.content}>
            {image && (
              <figure css={styles.img}>
                <Image
                  src={image.url}
                  alt={image.alt ?? h1}
                  width={430}
                  height={242}
                />
              </figure>
            )}
            <p css={typography.textL}>
              <b>{h1}</b>
            </p>
          </div>
        </Card>
      </a>
    </Link>
  )
}
